var path = 'components/liveEvents/tooltips/liveEventNetworksNames.html';
var html = "<div ng-repeat=\"name in le._networksNames() | orderBy track by $index\" ng-bind=name /> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;